import type { ChallengeFilterCategories, BaseFilterDisplayType } from '../types';
import { ASSIGNMENT_STATUS_NAMES } from '~/constants';

import { COMMON_FILTERS } from './common';

export const CHALLENGE_FILTERS: Record<ChallengeFilterCategories, BaseFilterDisplayType> = {
  ...COMMON_FILTERS,
  dueDate: { ...COMMON_FILTERS.dueDate, label: 'User Due Date' },
  reviewer: { label: 'Reviewer', iconName: 'filter-token-line:regular' },
  reviewerDueDate: { label: 'Reviewer Due Date', iconName: 'calendar:regular' },
};

const { passed, ...filterableStatusNames } = ASSIGNMENT_STATUS_NAMES;

export const CHALLENGE_STATUSES = filterableStatusNames;
